/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetSettingsListViewDto { 
    /**
     * Ключевое слово раздела настроек. Например, \"user-notifications\"
     */
    key: string;
    /**
     * Описание раздела настроек.
     */
    description: string;
}

